import ApiCrud from "./api-crud";

class OficinaService extends ApiCrud {
  resource = "oficinas";
  primaryKey = "idoficina";
}

export default new OficinaService();
